import React from 'react'
import ReactTable from 'react-table-6'
import { I18n } from 'react-redux-i18n'
import { Prices } from '@bdswiss/mt4-connector'
import { CouponInfo, BondClosedPosition } from '../types'
import BondClosed from './BondClosed'
import './PositionsTable.css'
import { currencySymbol, formatCurrency } from '../lib/currency-formatter'
import moment from 'moment'

export interface Props {
  assets: Prices
  closedPositions: BondClosedPosition[]
  currency: string
  locale: string
}

export interface State {
  filter: string
}

class HistoryTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { filter: 'active' }
  }

  public render() {
    const { currency, locale } = this.props
    const columns = [
      {
        expander: true,
        headerStyle: { display: 'none' },
        width: 30,
      },
      {
        // Header: 'Time',
        headerStyle: { display: 'none' },
        accessor: 'closeTime',
        minWidth: 60,
        Cell: (props: any) => {
          moment.locale(this.props.locale)
          const { closedTrade } = props.original
          const dateTime = moment(closedTrade.closeTime)
          return (
            <div>
              <div className="bdswiss-table--bold">{dateTime.format('MMM DD')}</div>
              <div>{dateTime.format('YYYY')}</div>
            </div>
          )
        },
      },
      {
        headerStyle: { display: 'none' },
        accessor: 'company',
        minWidth: 100,
        Cell: (props: any) => {
          moment.locale(locale)
          const { bond, coupons } = props.original
          const paidInterest = coupons.reduce(
            (acc: number, coupon: CouponInfo) => (acc += coupon.amount),
            0
          )
          return (
            <div>
              <div className="bdswiss-table--bold">{bond.name}</div>
              <div className="bdswiss-table--positive">
                {formatCurrency(paidInterest, currency, locale)}
              </div>
            </div>
          )
        },
      },
      {
        headerStyle: { display: 'none' },
        accessor: 'principal',
        minWidth: 60,
        Cell: (props: any) => {
          moment.locale(locale)
          const { closedTrade, bond } = props.original
          return (
            <div>
              <div className="bdswiss-table--bold bdswiss-table--right">
                {currencySymbol(bond.currency)}
                {closedTrade.volume.toFixed(2)}
              </div>
              <div className="bdswiss-table--right">{bond.couponInterestRate}%</div>
            </div>
          )
        },
      },
    ]

    return (
      <ReactTable
        noDataText={I18n.t('noClosedPositions')}
        // data={this.props.history.closedPositions!}
        data={this.props.closedPositions}
        columns={columns}
        className="bdswiss-table"
        showPagination={false}
        sortable={false}
        collapseOnDataChange={false}
        pageSize={110}
        defaultSorted={[
          {
            id: 'closeTime',
            desc: false,
          },
        ]}
        // style={{
        //   height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
        // }}
        getTrProps={(state: any, rowInfo: any, col: any, instance: any) => {
          return {
            onClick: () => {
              const { expanded } = state
              const path = rowInfo.nestingPath[0]
              const diff = { [path]: expanded[path] ? false : true }

              instance.setState({
                expanded: {
                  ...expanded,
                  ...diff,
                },
              })
            },
          }
        }}
        SubComponent={row => {
          return (
            <BondClosed
              position={row.original}
              // asset={assets[row.original.symbol]}
              currency={currency}
              locale={locale}
            />
          )
        }}
      />
    )
  }
}

export default HistoryTable
